module.exports = __webpack_public_path__ + "img/jiaotong.0c999ff6.png";